import { SelectFieldCanvaSX } from './SelectFieldCanvaSX';
import { TextFieldCanvaSX } from './TextFieldCanvaSX';
import { type FieldCanvaSXFactory } from './types';

const FieldCanvaSXComponents: Record<string, FieldCanvaSXFactory> = {
  SelectField: SelectFieldCanvaSX,
  TextField: TextFieldCanvaSX,
};

export default FieldCanvaSXComponents;
